import { injectable } from '~/container'
import {
  CampsiteDetails,
  ChargeType,
  ChargeTypesInput,
  QueryParams,
} from './types'

@injectable()
export abstract class CampsiteDetailsRepository {
  abstract get(
    slug: string,
    langCode: string,
    queryParams?: QueryParams,
  ): Promise<CampsiteDetails | void>
}

export abstract class CampsiteChargeTypesRepository {
  abstract get(input: ChargeTypesInput, langCode: string): Promise<ChargeType[]>
}
